angular.module('dpw.components')
    .factory('scrollSpy', [
        '$window', '$document', '$timeout', '$anchorScroll', '$location',
        function ($window, $document, $timeout, $anchorScroll, $location) {
            var spies = [];
            var windowEl = angular.element($window);
            var timeout = null;
            var activeTarget = null;
            var DELAY = 100;
            var OFFSET = 10;
            var firstSpy;
            var _scope;

            windowEl.on('scroll', doCheckPosition);
            windowEl.on('resize', doCheckPosition);

            function getOffsetTop (spy) {
                var nameAttrSelector = '[name="' + spy.target.substring(1) + '"]';
                var selector = spy.target.replace('.', '\\.');
                var targetEl = angular.element(selector)[0] || angular.element(nameAttrSelector)[0];
                $timeout(function () {
                    spy.offsetTop = targetEl ? getOffsetTop(targetEl) : null;
                });

                function getOffsetTop(el) {
                    return angular.element(el).offset().top + OFFSET * -1;
                }

                sortSpies();
            }

            function checkPosition () {
                if (!spies.length) {
                    return;
                }

                var scrollTop = $window.pageYOffset;

                // De-active spy when scrollTop is out of scroll spy's scope.
                if (scrollTop < firstSpy.offsetTop) {
                    deActiveCurrentSpy();
                    return;
                }

                for (var i = spies.length; i--;) {
                    var theSpy = spies[i];
                    if (angular.isUndefined(theSpy.offsetTop) || theSpy.offsetTop === null) continue;
                    if (activeTarget === theSpy.target) continue;
                    if (scrollTop < theSpy.offsetTop) continue;
                    if (spies[i + 1] && scrollTop >= spies[i + 1].offsetTop) continue;

                    deActiveCurrentSpy();
                    activateSpy(theSpy);
                }
            }

            function activateSpy(spy) {
                _scope.$emit('onScrollSpyActive');
                activeTarget = spy.target;
                spy.source.addClass('active');
                spy.source.parents('li').addClass('active');

                if ($ && $.fn && angular.isFunction($.fn.scrollintoview)) {
                    spy.source.scrollintoview();
                } else {
                    spy.source.get(0).scrollIntoView();
                }

            }

            function sortSpies () {
                spies
                    .filter(function (spy) {
                        return spy.offsetTop !== null;
                    })
                    .sort(function (a, b) {
                        return a.offsetTop - b.offsetTop;
                    });
                firstSpy = spies[0];
            }

            function deActiveCurrentSpy() {
                if (activeTarget) {
                    var activeSpy = getActiveSpy(activeTarget);
                    if (activeSpy) {
                        activeSpy.source.removeClass('active');
                        activeSpy.source.parents('li').removeClass('active');
                    }
                    activeTarget = null;
                }
            }

            function getActiveSpy(target) {
                var found = null;
                spies.forEach(function (spy) {
                    if (spy.target === target) {
                        found = spy;
                        return false;
                    }
                });
                return found;
            }

            function registerClickEvent (el) {
                el.source && el.source.on('click', function (event) {
                    event.preventDefault();
                    $location.hash(this.target.substring(1));
                    $anchorScroll();
                    doCheckPosition();
                });
            }

            function doCheckPosition () {
                if (timeout) {
                    $timeout.cancel(timeout);
                }
                timeout = $timeout(function () {
                    checkPosition();
                }, DELAY);
            }

            doCheckPosition();

            return {
                scope: function (scope) {
                    _scope = scope;
                    return this;
                },
                add: function (el) {
                    spies.push(el);
                    getOffsetTop(el);
                    registerClickEvent(el);
                },
                parseOffsets: function () {
                    for (var i = 0; i < spies.length; i++) {
                        getOffsetTop(spies[i]);
                    }
                    return this;
                },
                clean: function () {
                    activeTarget = null;
                    angular.forEach(spies, function (spy) {
                        if (spy.source.hasClass('active')) {
                            spy.source.removeClass('active');
                            spy.source.parents('li').removeClass('active');
                        }
                    });
                    return this;
                },
                reset: function () {
                    this.clean();
                    this.parseOffsets();
                    return this;
                }
            };
        }
    ])
    .directive('dpwScrollSpy', ['scrollSpy', function (scrollSpy) {
        return {
            restrict: 'EAC',
            link: function (scope, element, attrs) {
                var spy = {
                    source: element
                };

                if (angular.isDefined(attrs['target'])) {
                    spy.target = attrs.target;
                    scrollSpy.add(spy);
                }
            }
        }
    }])
    .directive('dpwScrollSpyList', ['$window', '$timeout', 'scrollSpy', function ($window, $timeout, scrollSpy) {
        return {
            restrict: 'EAC',
            link: function (scope, element) {
                var links = element.find('a');

                element.addClass('scroll-spy');
                scrollSpy.scope(scope);

                $($window).on('load', function () {
                    angular.forEach(links, function (link) {
                        var href = link.href;
                        var target = getHash(href) || getStringAfterLastSlash(href);

                        if (target) {
                            !link.target && angular.element(link).attr('target', target);
                            scrollSpy.add({
                                source: angular.element(link),
                                target: target
                            });
                        }
                    });
                });


                function getHash(location) {
                    var hashPosition = location.lastIndexOf('#');

                    return hashPosition > -1 ? location.substring(hashPosition) : '';
                }

                // Try to use the string after the last slash as target.
                function getStringAfterLastSlash(location) {
                    var lastSlashPosition = location.lastIndexOf('/');
                    var result = '';

                    if (lastSlashPosition) {
                        result = '#' + location.substring(lastSlashPosition + 1);
                    }

                    return result;
                }
            }
        };
    }]);